import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';

const InputMoreModal = (props) => {
    const [input, setInput] = useState("")
    const {isShow} = props
    const {inputValue} = props
    const {fieldTitle} = props
    const {onSave} = props
    const {onClose} = props

    useEffect(() => {
        setInput(inputValue)
    }, [inputValue])
    const onSaveInput = () => {
        onSave(input)
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Input more</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        {/*<div className='input-group mt-3'>*/}
                        {/*    <label className={'w-100'}>Referee ID: {refererId}</label>*/}
                        {/*</div>*/}
                        <div className='input-group mt-3'>
                            <label className={'w-100'}><b>{fieldTitle}</b></label>
                            <textarea className='form-control'
                                   value={input}
                                   name={'input'}
                                   onChange={event => setInput(event.target.value)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            onClick={() => {
                                onSaveInput()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default InputMoreModal;
